import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { installFetchProxy } from "./offline/fetchProxy";
import { isPublicStandalonePath } from "./utils/publicStandaloneRoutes";
import { installChartSyncTriggers } from './offline/chartSync';
import {
  announceServiceWorkerUpdate,
  registerServiceWorkerControllerRefresh,
} from './serviceWorkerRefresh';

const root = ReactDOM.createRoot(document.getElementById("root"));
installFetchProxy();
installChartSyncTriggers();
root.render(
  <App />
);

// Service worker update discovery and explicit activation glue.
//
// Flow:
//   1. registerValidSW() detects a new SW and calls onUpdate.
//   2. onUpdate leaves the worker waiting and surfaces
//      `vela:sw-update-available` so React can show the existing banner.
//   3. Only the tab whose user clicks Update Sena sends the explicit apply
//      message and arms its activation reload. Sibling tabs never reload.
const SW_REFRESHED_KEY = 'vela:sw-refreshed';

const markServiceWorkerRefresh = () => {
  try {
    sessionStorage.setItem(SW_REFRESHED_KEY, String(Date.now()));
  } catch {
    // Storage can be unavailable in private browsing; the refresh should still proceed.
  }
};

const applyServiceWorkerUpdate = registerServiceWorkerControllerRefresh({
  onRefresh: markServiceWorkerRefresh,
});

serviceWorkerRegistration.register({
  updateViaCache: 'none',
  onUpdate: (registration, installedWorker) => {
    announceServiceWorkerUpdate({
      registration,
      installedWorker,
      isPublicStandalone: isPublicStandalonePath(),
      applyServiceWorkerUpdate,
    });
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
